import { AuthPromoSection } from '../AuthPromoSection/AuthPromoSection'
import { AuthTopNav } from '../../../components/TopNav/AuthTopNav'
import { AuthenticationForm } from '@dtx-company/inter-app/src/components/Authentication/AuthenticationForm'
import { FC } from 'react'
import { GridLayout } from '../../../components/layout/GridLayout/GridLayout'
import { SignupProps } from './SignupPageContainer.types'
import { Stack, theme } from '@dtx-company/design-system/src'

export const SignupPageContainer: FC<SignupProps> = ({
  fromFlowpage,
  planTypeQueryParams,
  inviteState
}) => {
  return (
    <GridLayout
      headerSlot={{
        children: <AuthTopNav color="onSurface.inverse" secondarySlotHiddenOnMobile />
      }}
      primarySlot={{
        children: (
          <Stack sx={theme => ({ maxWidth: theme.spacing(115) })}>
            <AuthenticationForm
              action="sign up"
              product={fromFlowpage ? 'flowpage' : 'flowcode'}
              planTypeQueryParams={planTypeQueryParams}
              inviteState={inviteState}
            />
          </Stack>
        ),
        verticalAlignment: 'center'
      }}
      secondarySlot={{
        children: (
          <AuthPromoSection inviteState={inviteState} planTypeQueryParams={planTypeQueryParams} />
        ),
        backgroundColor: theme.brand.navy,
        backgroundImgSrc: '/images/signup/signup-bg.png',
        graphicPosition: 'background',
        hideOnMobile: true
      }}
    />
  )
}
